var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMarkerDrone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.04091 6C3.70608 6 3.43491 6.37336 3.43491 6.83442H4.64709C4.64705 6.3733 4.3755 6 4.04091 6ZM8.08187 7.27148H0V9.17737H8.08187V7.27148ZM19.9588 9.79248C19.3726 9.79248 18.8974 10.4461 18.8974 11.2517V12.2295L15.9792 13.0067C15.5021 13.0067 14.9715 12.8222 14.3872 12.6191C13.6718 12.3703 12.876 12.0936 11.9999 12.0936C11.1235 12.0936 10.3276 12.3704 9.61206 12.6191C9.02788 12.8223 8.4973 13.0067 8.02027 13.0067L5.1019 12.2295V11.2517C5.1019 10.4462 4.62691 9.79248 4.04079 9.79248C3.45462 9.79248 2.97964 10.4461 2.97964 11.2517V15.8144C2.97964 16.62 3.45457 17.2736 4.04079 17.2736C4.62691 17.2736 5.1019 16.62 5.1019 15.8144V14.9543C5.94977 15.1982 7.1184 15.532 7.88766 15.7438C8.41838 15.8897 8.80044 16.4153 9.22071 16.9934C9.85103 17.8605 10.5673 18.8457 11.9999 18.8457C13.4323 18.8457 14.1486 17.8605 14.7789 16.9935C15.1992 16.4154 15.5813 15.8898 16.112 15.7438C16.8812 15.532 18.0496 15.1982 18.8974 14.9543V15.8144C18.8974 16.62 19.3726 17.2736 19.9588 17.2736C20.5449 17.2736 21.0199 16.62 21.0199 15.8144V11.2517C21.0199 10.4461 20.5449 9.79248 19.9588 9.79248ZM15.9179 7.27148H23.9999V9.17737H15.9179V7.27148ZM19.3528 6.83442C19.3528 6.37336 19.624 6 19.959 6C20.2934 6 20.5649 6.3733 20.565 6.83442H19.3528Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarkerDrone);
export default __webpack_public_path__ + "static/media/icon_marker_drone.a1e3879659355e3a4a35e706ac682135.svg";
export { ForwardRef as ReactComponent };